import { gql } from "@apollo/client";

export const GET_ALL_EXPERTS = gql`
  query getAllExperts {
    getAllExperts {
      statusCode
      message
      response
    }
  }
`;

// mutations

export const CREATE_EXPERT = gql`
  mutation createExpert($input: inputExpert) {
    createExpert(input: $input) {
      statusCode
      message
      response
    }
  }
`;
